import instance from "@/utils/require.js"

// SAP工单--分页查询
export function apiSapOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/search",
		method: "post",
		data
	})
}

export function apiSapShipmentOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/shipment_order/search",
		method: "post",
		data
	})
}

export function apiSapReportedExport(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/reported/export",
		method: "post",
		data
	})
}
// SAP工单--分页查询
export function apiSapDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/detail",
		method: "post",
		data
	})
}
export function apiSapShipmentDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/shipment_order/detail",
		method: "post",
		data
	})
}
// SAP工单--分页查询
export function apiSapProcessSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/process/search",
		method: "post",
		data
	})
}
export function apiSapWerksList(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/werks/list",
		method: "post",
		data
	})
}
export function apiSapStorageSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/storage/search",
		method: "post",
		data
	})
}
// SAP工单--入库
export function apiSapOrderStorage(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/storage",
		method: "post",
		data
	})
}
export function apiSapOrderStorageRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/storage/rollback",
		method: "post",
		data
	})
}
export function apiSapOrderValidXblnr(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/valid_xblnr",
		method: "post",
		data
	})
}

// SAP工单--入库
export function apiSapLgortList(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/lgort/list",
		method: "post",
		data
	})
}
// SAP工单--分页查询
export function apiSapItemsSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/items/search",
		method: "post",
		data
	})
}

export function apiSapOrderItemsGrnSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/items/grn/search",
		method: "post",
		data
	})
}

export function apiSapOrderItemsGrnFeed(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/items/grn/feed",
		method: "post",
		data
	})
}

// SAP交货单发货记录--分页查询
export function shipmentOrderRecordSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/shipment_order_record/search",
		method: "post",
		data
	})
}
// SAP交货单 退货
export function shipmentOrderRecordBack(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/shipment_order_record/back",
		method: "post",
		data
	})
}
// SAP交货单 退货
export function shipmentOrderRecordBatchBack(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/shipment_order_record/BatchBack",
		method: "post",
		data
	})
}
// SAP工单--工序报工记录查询
export function apiSapOrderReportedSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/reported/search",
		method: "post",
		data
	})
}
export function apiSapOrderReportedSearch2(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/reported/search",
		method: "post",
		data
	})
}

// SAP工单--工序报工
export function apiSapOrderReported(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/reported",
		method: "post",
		data
	})
}
// SAP工单--工序取消报工
export function apiSapOrderRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/rollback",
		method: "post",
		data
	})
}

// 导出套料单
export function apiSapOrderItemExport(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/order_item_print",
		method: "post",
		data:data,
		responseType: 'blob'
	})
}
// SAP打印入库单
export function apiSapOrderStoragePrint(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/order_storage_print",
		method: "post",
		data:data,
		responseType: 'blob'
	})
}
// SAP入库记录导出
export function apiSapStorageExport(data = {}) {
	return instance({
		url: "/aim/api/v3/sap/order/storage/export",
		method: "post",
		data
	})
}